import { useUpdateEffect } from 'react-use';

import { FormContextValues } from '@dreryk/react-common';
import { Checkbox, FormLabel, StyledFlex } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../../translations';

import { DoctorSpecialtiesValue } from './DoctorSpecialtiesInteractiveTable';

export type NoSpecialtyValue = { noSpecialty: boolean };
type NoSpecialtyCheckboxProps = Pick<FormContextValues<NoSpecialtyValue>, 'register' | 'trigger'> &
   Partial<DoctorSpecialtiesValue>;

export const NoSpecialtyCheckbox = (props: NoSpecialtyCheckboxProps): JSX.Element => {
   const controller = props.register('noSpecialty', {
      validate: (checked) => {
         if (checked) {
            return undefined;
         }

         if (!props.doctorSpecialties?.length) {
            return personnelTranslationKeys.specialtiesTable.completionRequired;
         }

         const specialtiesNotFilled = props.doctorSpecialties?.every(
            (doctorSpecialty) => !doctorSpecialty.medicalSpecialty
         );
         if (specialtiesNotFilled) {
            return personnelTranslationKeys.specialtiesTable.completionRequired;
         }

         return undefined;
      },
   });

   useUpdateEffect(() => {
      props.trigger('noSpecialty');
   }, [props.doctorSpecialties]);

   return (
      <StyledFlex direction={'column'} gap={'8px'}>
         <FormLabel
            testId={'doctorSpecialtyLabel'}
            label={personnelTranslationKeys.specialtiesTable.specialty}
            required
         />
         <Checkbox
            controller={controller}
            testId={'noSpecialty'}
            label={personnelTranslationKeys.specialtiesTable.noSpecialty}
         />
      </StyledFlex>
   );
};
